module.exports = __webpack_public_path__ + "static/media/dm.b080dd14.svg";